import { StateCreator } from 'zustand';

import { getFrequencyValue } from '@common/calculations';
import { TERM_QUOTE_STEPS } from '@termquote/constants';

import { LayoutSliceState, TermQuoteStoreState } from './types';

export const layoutSlice: StateCreator<
  TermQuoteStoreState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  LayoutSliceState
> = (set, get) => ({
  userDetailsModal: false,
  planDetailsModal: false,
  premiumChangeInfoType: null,
  premiumChangeTitle: '',
  premiumChangeDesc: '',
  showUserDetailsModal: () => {
    set((state) => {
      state.userDetailsModal = true;
    });
  },
  hideUserDetailsModal: () => {
    set((state) => {
      state.userDetailsModal = false;
    });
  },
  showPlanDetailsModal: () =>
    set((state) => {
      state.planDetailsModal = true;
    }),
  hidePlanDetailsModal: () =>
    set((state) => {
      state.planDetailsModal = false;
    }),
  showPremiumChangeModal: (premium: number) => {
    let title = '',
      desc = '',
      infoType = '';
    if (get().step >= TERM_QUOTE_STEPS.PLAN_DETAILS) {
      infoType = 'modal';
      title = 'Your premium is updated';
      desc = `Due to the changes you made, your premium is revised to ${getFrequencyValue(
        premium,
        2
      )}/- for this plan.`;
    } else {
      infoType = 'toast';
      title = 'Premiums are updated';
      desc = 'Due to the changes you made, we had to update the premiums';
    }
    set((state) => {
      state.premiumChangeInfoType = infoType;
      state.premiumChangeTitle = title;
      state.premiumChangeDesc = desc;
    });
  },
  hidePremiumChangeModal: () => {
    set((state) => {
      state.premiumChangeInfoType = null;
      state.premiumChangeTitle = '';
      state.premiumChangeDesc = '';
    });
  }
});
